
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"120","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"4","y":"4","width":"92","height":"112","rx":"4","fill":"#fff"}}),_c('rect',{attrs:{"x":"2","y":"2","width":"96","height":"116","rx":"6","stroke":"#C2C2C2","stroke-opacity":".18","stroke-width":"4"}}),_c('rect',{attrs:{"x":"4","y":"4","width":"92","height":"112","rx":"4","fill":"#fff"}}),_c('rect',{attrs:{"x":"3","y":"3","width":"94","height":"114","rx":"5","stroke":"#C2C2C2","stroke-opacity":".18","stroke-width":"2"}}),_c('rect',{attrs:{"x":"3.5","y":"3.5","width":"93","height":"113","rx":"4.5","stroke":"#C2C2C2","stroke-opacity":".4"}}),_c('path',{attrs:{"opacity":".04","d":"M24.677 97.334c10.94 5.101 26.796-9.631 31.958-15.908 11.413-13.877 38.43-12 34.802-40.264-2.103-16.394-15.714-22.452-34.802-25.386-19.088-2.933-39.109 9.104-40.135 23-1.355 18.354-4.725 18.557-6.913 32.793-2.053 13.361 2.83 20.05 15.09 25.765z","fill":"#0CF"}}),_c('rect',{attrs:{"opacity":".8","x":"34","y":"90","width":"32","height":"14","rx":"7","fill":"#39AE61"}}),_c('path',{attrs:{"opacity":".8","fill":"#0CF","d":"M24 36h52v6H24z"}}),_c('path',{attrs:{"opacity":".4","fill":"#9AA5BB","fill-opacity":".75","d":"M16 52.901h68v4.552H16zM30 62.005h40v4.552H30z"}})])
          )
        }
      }
    